
(function() {
  var result = { translations: { "zh-hk": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u9418", "hours": "{{ hours }} \u5C0F\u6642", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206\u9418", "days": "{{ days }} \u65E5", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206", "hours": "{{ hours }} \u5C0F\u6642", "days": "{{ days }} \u65E5", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63 " }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "zh-hk": "static-7.1179"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1179",
    "ar-eg": "static-7.1179",
    "bg": "static-7.1179",
    "bn": "static-7.1179",
    "ca-es": "static-7.1179",
    "cs": "static-7.1179",
    "da": "static-7.1179",
    "de": "static-7.1179",
    "el": "static-7.1179",
    "en-gb": "static-7.1179",
    "en": "static-7.1179",
    "es-mx": "static-7.1179",
    "es": "static-7.1179",
    "et": "static-7.1179",
    "fi": "static-7.1179",
    "fr-ca": "static-7.1179",
    "fr": "static-7.1179",
    "he-il": "static-7.1179",
    "hi": "static-7.1179",
    "hr": "static-7.1179",
    "hu": "static-7.1179",
    "id": "static-7.1179",
    "it": "static-7.1179",
    "ja": "static-7.1179",
    "ko": "static-7.1179",
    "lt": "static-7.1179",
    "ms": "static-7.1179",
    "nl": "static-7.1179",
    "no": "static-7.1179",
    "pl": "static-7.1179",
    "pt-br": "static-7.1179",
    "pt-pt": "static-7.1179",
    "ro": "static-7.1179",
    "ru": "static-7.1179",
    "sk": "static-7.1179",
    "sl": "static-7.1179",
    "sv": "static-7.1179",
    "th": "static-7.1179",
    "tl": "static-7.1179",
    "tr": "static-7.1179",
    "uk": "static-7.1179",
    "vi": "static-7.1179",
    "x-pseudo": "static-7.1179",
    "zh-cn": "static-7.1179",
    "zh-hk": "static-7.1179",
    "zh-tw": "static-7.1179"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-hk', {version: 'static-7.1179'}); }
})();


